module.exports = __webpack_public_path__ + "static/img/manual1.b6a1c103.png";